import { useRouter } from 'next/router';
import { UseQueryOptions, useQuery } from 'react-query';
import { getCourseDetails } from '../../apis/tms/course.api';
import { COURSE_INFO } from '../../constant/QueryKeyName';
import { ICourseDetailResponse } from '../../interfaces/training.interface';

export const useFetchCourseDetails = (
  opt?: Omit<
    UseQueryOptions<unknown, Error, ICourseDetailResponse, string[]>,
    'queryKey' | 'queryFn'
  >
) => {
  const router = useRouter();
  const { cid: courseId } = router.query;
  const queryReturn = useQuery(
    [COURSE_INFO, courseId as string],
    () => getCourseDetails(courseId as string),
    {
      ...opt,
      enabled: !!courseId,
      staleTime: 10 * 60 * 1000,
    }
  );

  return { queryReturn };
};
